import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "home-container"
};
import Footer from '../components/Footer.vue';
import SearchHeader from '@/components/SearchHeader.vue';
import Category from '@/components/Category.vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import request from '@/utils/request';
import { useCourseStore } from '@/stores/courseStore';
import { useUserStore } from '@/stores/userStore';
import { useViewCountStore } from '@/stores/viewCountStore';
import { useCategoryStore } from '@/stores/categoryStore';
import Cookies from 'js-cookie';
import { ElMessage } from 'element-plus';
import { useVideoStore } from '@/stores/videoStore';
export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {
    const router = useRouter();
    const courseStore = useCourseStore();
    const userStore = useUserStore();
    const viewCountStore = useViewCountStore();
    const categoryStore = useCategoryStore();
    const videoStore = useVideoStore();
    //获取最新ppt和其他
    const getPPTList = async () => {
      try {
        const res = await courseStore.fetchCourseList(5);
        courseStore.setCourseList(res.list);
        // console.log(res);
        // courseStore.isGetPPTList = true;
      } catch (error) {
        // ElMessage.error('获取PPT列表失败');
        console.error('获取PPT列表失败');
      }
    };
    //获取最新的五个微课
    const getVideoList = async () => {
      try {
        const res = await videoStore.fetchVideoList(5);
        // console.log(res);
        videoStore.setVideoList(res.list);
      } catch (error) {
        console.error('获取微课列表失败');
      }
    };
    //获取用户资源
    const getUserResource = async () => {
      await userStore.asyncGetUserResource();
    };
    // 检查token是否过期
    const checkTokenExpired = async () => {
      try {
        const token = Cookies.get('token');
        if (!token) {
          // ElMessage.error('请先登录');
          // router.push('/login');
          userStore.logout();
        } else {
          const res = await request({
            url: '/api/auth/checkToken',
            method: 'get',
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          // console.log(res);
          if (res.data.message === 'Token已过期') {
            userStore.logout();
          } else {
            getUserResource();
          }
        }
      } catch (error) {
        // console.log(error);
        ElMessage.error('获取用户资源失败');
      }
    };
    //增加网站浏览量
    const addSiteViewCount = () => {
      viewCountStore.addSiteViewCount();
    };
    //获取分类列表
    const getCategoryList = async () => {
      await categoryStore.fetchCategoryList();
    };
    onMounted(() => {
      //检查token是否过期
      checkTokenExpired();
      //获取最新ppt和其他
      getPPTList();
      //增加网站浏览量
      addSiteViewCount();
      //获取分类列表
      getCategoryList();
      //获取最新的五个微课
      getVideoList();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchHeader), _createVNode(Category), _createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 2
        }, 1024)]),
        _: 1
      }), _createVNode(Footer)]);
    };
  }
});